module.exports = __webpack_public_path__ + "static/qrcode-35bf233bb683dbd0e77d8f2ba8351b8f.svg";